import React from 'react';
import PropTypes from 'prop-types';
import googleLogo from '../../../../assets/images/login/icon-google-small.svg';

class GoogleButton extends React.Component {

    render() {
        const { onClickAction, authInProcess, title, className } = this.props;
        return (
            <button className={`google-button ${authInProcess && 'btn-loader-light'} ${className}`}
                onClick={onClickAction}><img src={googleLogo} />{title}
            </button>
        );
    }
}

GoogleButton.propTypes = {
    onClickAction: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    authInProcess: PropTypes.bool,
};

export default GoogleButton;
